export interface TruckAnniversaryTextProps {
  customerName: string;
  personalMessage?: string;
  senderName?: string;
}

const firstName = (fullName: string): string => {
  const parts = (fullName || '').trim().split(/\s+/).filter(Boolean);
  return parts[0] || 'friend';
};

export const truckAnniversaryText = async (
  params: TruckAnniversaryTextProps,
): Promise<{ body: string }> => {
  const { customerName, personalMessage, senderName } = params;
  const greetingName = firstName(customerName);
  const personal = (personalMessage || '').trim();

  const sections = [
    `Happy truck-iversary, ${greetingName}! 🚚 Hope the truck has been treating you well.`,
  ];

  if (personal) sections.push(personal);

  sections.push(
    senderName
      ? `– ${senderName}, Optic Truck Works`
      : '– The Optic Truck Works Team',
  );

  return { body: sections.join('\n\n') };
};
